module.exports = __webpack_public_path__ + "static/img/img_r.5688b800.png";